<template>
	<div class="about-xhorse">
		<div class="title">
			<i class="x-icon-about"></i><span class="x-tit-con">About Xhorse</span>
		</div>
		<div class="content">
			<div class="x-img"></div>
			<div class="x-det">
				<div class="x-det-name">
					<i class="x-icon-left"></i>
					<span>Science and Technology Dream beyond Imagination</span>
					<i class="x-icon-right"></i>
				</div>
				<div class="x-det-con">
					<div class="txt lf-con x-flow">
						Xhorse, as a national level high-tech enterprise based on intelligent manufacturing, has been always exploring new possibilities for intelligent manufacturing and life, and committed to changing life through science and technology.
					</div>
					<div class="txt lr-con x-flow">
						<p>
							Located in Shenzhen, China, Xhorse Electronics Co., Ltd is the leading manufacturer specialized in R&D intelligent devices in the industry of automotive security. Since its establishment in 2010, Xhorse has experienced a remarkable development and possessed a complete system of Independent Intellectual Property Rights. It is dedicated to providing security products and solutions worldwide. </p>

						<p>
							Xhorse sees the importance of continuous research and development to find on-going solutions in a fast-paced industry of automotive security. It has set up the professional electronic labs and automation labs, the integrated production line. Xhorse unswervingly takes extreme care about minute details to guarantee product quality.</p>

						<p>
							The on-going development of Xhorse can be demonstrated by technology-driven innovation. While devoting itself to keep up with the latest globalization tendency of science and technology, At the same time, Xhorse adheres to cooperate with more partners and will be dedicated to providing better security solutions and after-sale service for all the Xhorse users worldwide.</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

    export default {}

</script>

<style scoped>

	.about-xhorse {
		background: #FFFFFF;
		min-width: 61.5rem;
		min-height: 70.3125rem;
		padding-bottom: .75rem;
		border-bottom: .75rem solid #F7F8F8;
		overflow: hidden;
	}

	.about-xhorse > .title {
		width: calc(100% - 3.25rem);
		margin-left: 3.25rem;
		text-align: left;
		padding-top: 2.75rem;
		padding-bottom: 2.75px;
		line-height: 2.75px;
	}

	.about-xhorse > .content {
		border: none;
		width: 54.5rem;
		/*min-height: 56.5rem;*/
		margin-left: 7rem;
	}

	.title > .x-icon-about {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_we_xhorse.png");
		width: 2.75rem;
		height: 2.75rem;
		position: relative;
		top: .625rem;
		margin-right: 1rem;
	}

	.title > .x-tit-con {
		display: inline-block;
		width: calc(100% - 3.75rem);
		height: 2.75rem;
		font-family: Open Sans;
		font-size: 1.5rem;
		color: #3B3A38;
	}

	.content > .x-img {
		width: 54.5rem;
		height: 20rem;
		background: url("../../../assets/resource/images/home/image_we_01.png") no-repeat center;
		margin-bottom: 2.75rem;
		background-size: 100% 100%;
	}

	.content > .x-det {
		width: 54.5rem;
	}

	.x-det > .x-det-name, .x-det > .x-det-con {
		border: none;
		width: 54.5rem;
	}

	.x-det-con {
		width: 54.5rem;
		height: 28.5rem;
		padding: 0;
	}

	.x-det-name {
		height: 3.25rem;
		margin-bottom: 2.125rem;
		position: relative;
	}

	.x-det-name > span {
		width: 41.4375rem;
		display: block;
		height: 100%;
		font-family: Palatino-Roman;
		font-size: 1.625rem;
		color: #515555;
		line-height: 3.25rem;
		text-align: left;
		word-wrap: normal;
		white-space: nowrap;
	}

	.x-det-con > .lf-con {
		font-family: Open SLI;
		font-size: 1rem;
		color: #515555;
		letter-spacing: 0;
		text-align: justify;
		line-height: 1.5rem;
	}

	.lf-con {
		border: none;
		width: calc(20.4375rem - 1.6875rem - 4.1875rem);
		padding-left: 1.6875rem;
		margin-right: 4.1875rem;
		border-left: .125rem solid #F5A623;
	}

	.lr-con {
		border: none;
		width: 33.9375rem;
		font-family: Open Sans;
		font-size: 1rem;
		color: #515555;
		letter-spacing: 0;
		text-align: justify;
		line-height: 1.5rem;
		padding: 0;
	}

	.lr-con > p:nth-child(1), .lr-con > p:nth-child(2) {
		border: none;
		margin-bottom: 1.375rem;
	}

	.x-det-con > .txt > p {
		font-size: 1rem;
		color: #515555;
		letter-spacing: 0;
		text-align: justify;
		line-height: 1.5rem;
	}

	.x-icon-left {
		display: block;
		content: url("../../../assets/resource/icons/ico_home_punctuation_left.png");
		width: 2.625rem;
		height: 1.625rem;
		position: absolute;
		left: 0;
		top: 0;

	}

	.x-icon-right {
		display: block;
		content: url("../../../assets/resource/icons/ico_home_punctuation_right.png");
		width: 2.625rem;
		height: 1.625rem;
		position: absolute;
		right: calc(100% - 41.4375rem);
		bottom: 0;

	}
</style>


// WEBPACK FOOTER //
// src/components/zh-cn/about/about-xhorse.vue